export * from "./wallet-accept.component";